import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/newBack.png'


const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "home-top-container" }
const _hoisted_3 = { class: "title-container" }
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "home-top-right"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "lft-part" }
const _hoisted_10 = {
  key: 1,
  class: "home-top-right"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "lft-part" }
const _hoisted_14 = { class: "content-container" }
const _hoisted_15 = {
  key: 0,
  class: "subScene-video-container"
}

import {ref,reactive,onMounted,onBeforeUnmount,computed, watch, getCurrentInstance} from 'vue'
import ScenePage from '@/views/scene/index.vue'
import SubScenePage from '@/views/subScene/index.vue'
import ThirdScenePage from '@/views/thirdScene/index.vue'
import {useStore} from 'vuex'
import {useRouter, useRoute} from 'vue-router'
import {getSystemTime} from '@/utils/index'
import {createTraining, trackStatistic, getTeachingSceneInfoTab, getExerciseSceneInfoTab, getPrimaryPageButtons, PrimaryPageButton} from '@/service'
import{testCardData} from '@/utils/testData'
import {$config, $enum} from "@/global";

const enum ButtonCodeEnum {
  技能考评 = 'SKILL_ASSESSMENT',
  教程中心 = 'TUTORIAL_CENTER',
  理论题库 = 'QUESTION_BANK',
  地面站 ='GROUND_STATION',
  视频教学 = 'VIDEO_TEACHING',
  新手教学 = 'NOVICE_TEACHING',
  练习场	= 'PRACTICE_GROUND',
  设备认识	= 'DEVICE_GUIDE', 
  缺陷认识 = 'DEVICE_DEFECT',
  学习计划 = 'LEARNING_PLAN'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { proxy } = getCurrentInstance()!
const store = useStore()
const router = useRouter()
const route = useRoute()
const breadcrumb = computed(() => store.state.persistence.breadcrumb)
const currentPage = computed(() => breadcrumb.value[breadcrumb.value.length-1].currentPage)
const primaryButtonList = ref<PrimaryPageButton[]>([])
const actionButtonList = ref<PrimaryPageButton[]>([])
const showVideoPlayer = ref(false);
const videoResource = ref('')
const showPlanModal = ref(false)

const courseTypeId = computed(()=>{
  if(currentPage.value == 2){
    return store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-1].courseTypeId
  }
  return null
})


watch(currentPage, (newVal, oldVal) => {
  trackStatisticPageView(newVal)
  if(newVal == 1){
    loadPrimaryPageButtons()
  }
})

watch(()=>store.state.persistence.currentTenantId,(newValue)=>{
  if(newValue){
    handleJump(1)
    loadPrimaryPageButtons()
  }
})

async function loadPrimaryPageButtons(){
  try {
    const {code, data, message} = await getPrimaryPageButtons()
    if (code != $enum.EnumResult.SUCCESS) {
      primaryButtonList.value = []
      proxy?.vknMessage.error(message)
      return
    }
    primaryButtonList.value = Array.isArray(data) ? data.filter(item => item?.buttonCode) : []
  } catch (error) {
    primaryButtonList.value = []
    console.error('getPrimaryPageButtons error', error)
  }
}

function handleGetActionButton(list:PrimaryPageButton[]){
  actionButtonList.value = []
  actionButtonList.value = list
}

function trackStatisticPageView(pageIndex: number) {
  const eventTime = getSystemTime()
  const {appId, userId} = store.state.persistence.userInfo
  const page = breadcrumb.value[pageIndex - 1].path
  trackStatistic([{appId,userId,eventKey:"simulator_page_view",eventTime,params:{page}}])
}

function handleJump(pageIndex:number){
  window?.playClick()
  if(pageIndex == currentPage.value) return
  if(currentPage.value == 3 && (pageIndex == 2 || pageIndex == 1)){
    store.commit('persistence/setCarouselSelection', {
      ...store.state.persistence.carouselSelection,
      thirdSceneCardId: null
    })
  }
  if(currentPage.value == 3 && pageIndex == 2){
    let arr = [...breadcrumb.value]
    arr.pop()
    arr[arr.length-1].active = true
    store.commit('persistence/setBreadcrumb',arr)
  }else if(pageIndex == 1){
    if(store.state.persistence.breadcrumb.length > 1){
      let firstObje = store.state.persistence.breadcrumb[0]
      firstObje.active = true
      store.commit('persistence/setBreadcrumb',[firstObje])
    }
  }
}

function openRedirectUrl(
  redirectUrl?: string | null,
  query?: Record<string, string | number | null | undefined>,
  inheritSessionStorage = false
){
  if(!redirectUrl) return
  const url = new URL(redirectUrl, window.location.origin)
  Object.entries(query || {}).forEach(([key, value]) => {
    if(value !== null && value !== undefined && value !== ''){
      url.searchParams.set(key, String(value))
    }
  })
  if(inheritSessionStorage && url.origin === window.location.origin){
    window.open(url.toString(), '_blank')
    return
  }
  window.open(url.toString(), '_blank', 'noopener')
}

function  handleClickAction(item:PrimaryPageButton){
  if(!item?.buttonCode) return;
  window?.playClick()
  switch (item?.buttonCode) {
    case ButtonCodeEnum.技能考评:
      openRedirectUrl(item?.redirectUrl)
      break;
    case ButtonCodeEnum.教程中心:
      router.push('/secondary/tutorial-center')
      break;
    case ButtonCodeEnum.理论题库:
      openRedirectUrl(item?.redirectUrl, {
        sceneTypeId: breadcrumb.value[breadcrumb.value.length - 1]?.id
      })
      break;
    case ButtonCodeEnum.地面站:
      // 地面站依赖新窗口继承当前同源页面的 sessionStorage（my-data）。
      openRedirectUrl(item?.redirectUrl, undefined, true)
      break;
    case ButtonCodeEnum.视频教学:
      videoResource.value = `${$config.FILE_ROOT_PATH}${item?.videoUrl}`
      showVideoPlayer.value = true;
      break;
    case ButtonCodeEnum.新手教学:
      getSceneInfoData(item?.sceneCategoryId)
      break;
    case ButtonCodeEnum.练习场:
      getSceneInfoData(item?.sceneCategoryId)
      break;
    case ButtonCodeEnum.设备认识:
      store.commit('persistence/setTowerIdentify', {
        ...store.state.persistence.towerIdentify,
        sceneCategoryId:item?.sceneCategoryId,
        sceneTypeId:store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-1].id,
        title:item?.name
      })
      router.push('/secondary/tower')
      break;
    case ButtonCodeEnum.缺陷认识:
      router.push('/secondary/defect-review')
      break;
    case ButtonCodeEnum.学习计划:
      showPlanModal.value = true;
      break;
    default:
      console.warn('unknown buttonCode', item?.buttonCode);
  }
}


async function getSceneInfoData(type:number | string){
   let param = {
    "userId": store.state.persistence.userInfo.userId,
    "tenantId": store.state.persistence.currentTenantId,
    "sceneTypeId": store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-1].id
  }
  let code = undefined, data = undefined, message = undefined;
  if(type == 3){
    //教学
    ({code, data, message} = await getTeachingSceneInfoTab(param));
  }else if(type == 5){
    //训练场
    ({code, data, message} = await getExerciseSceneInfoTab(param));
  }
  if (code != $enum.EnumResult.SUCCESS) {
    proxy?.vknMessage.error(message)
    return
  }
  if(data && Object.keys(data).length > 0){
    let params = {
      userId:store.state.persistence.userInfo.userId,
      sceneId:data?.id,
      uavSpecificationId:store.state.persistence.currentUavInfo.uavId,
      stationId:data?.stationId,
    }
    const res = await createTraining(params);
    if(res.code != $enum.EnumResult.SUCCESS){
      proxy?.vknMessage.error(res.message)
      return
    }
    const trainData = res.data;
    const {trainingId} = trainData as any || {};
    store.commit('persistence/setCurrentUavInfo', {
    ...store.state.persistence.currentUavInfo,
      nestId:data?.uavNestId,
      trainingId,
      heightLimit:data?.heightLimit,
      parentName:type,
      sceneImageUrl:data?.scenePictureUrl,
      sceneInfo:data,
      resourceFileList:data?.resourceFileList,
      windSpeedIndex:'',
      windDirectionIndex:''
    });
    store.commit("persistence/setStationId", data?.stationId);
    router.push('/flight/guide')
  }
}

onMounted(()=>{
  trackStatisticPageView(currentPage.value)
  loadPrimaryPageButtons()
})

return (_ctx: any,_cache: any) => {
  const _component_vkm_videoPlayer = _resolveComponent("vkm-videoPlayer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (currentPage.value == 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "home-icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleJump(currentPage.value)))
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "iconfont-fill vk_swll_fill" }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _imports_0,
              alt: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handleJump(currentPage.value - 1)))
            })),
        _createElementVNode("p", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumb.value, (item, index) => {
            return (_openBlock(), _createElementBlock("span", {
              class: _normalizeClass(item?.active?'active':''),
              key: index,
              onClick: ($event: any) => (handleJump(item.currentPage))
            }, _toDisplayString(item?.name) + " " + _toDisplayString(item?.active?'':'>'), 11, _hoisted_5))
          }), 128))
        ])
      ]),
      (currentPage.value == 1 && primaryButtonList.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(primaryButtonList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "home-top-right-item",
                key: index,
                onClick: ($event: any) => (handleClickAction(item))
              }, [
                _createElementVNode("img", {
                  class: "icon-img",
                  src: _unref($config).FILE_ROOT_PATH+item?.iconUrl,
                  alt: ""
                }, null, 8, _hoisted_8),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", null, _toDisplayString(item?.name), 1),
                  _createElementVNode("span", null, _toDisplayString(item?.description), 1)
                ])
              ], 8, _hoisted_7))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (currentPage.value == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionButtonList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "home-top-right-item",
                key: index,
                onClick: ($event: any) => (handleClickAction(item))
              }, [
                _createElementVNode("img", {
                  class: "icon-img",
                  src: _unref($config).FILE_ROOT_PATH+item?.iconUrl,
                  alt: ""
                }, null, 8, _hoisted_12),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("p", null, _toDisplayString(item?.name), 1),
                  _createElementVNode("span", null, _toDisplayString(item?.description), 1)
                ])
              ], 8, _hoisted_11))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      (currentPage.value == 1)
        ? (_openBlock(), _createBlock(ScenePage, { key: 0 }))
        : _createCommentVNode("", true),
      (currentPage.value == 2)
        ? (_openBlock(), _createBlock(SubScenePage, {
            key: 1,
            onOnGetActionButtons: handleGetActionButton,
            onOnCloseStudyPlanModal: _cache[2] || (_cache[2] = ()=>{showPlanModal.value = false}),
            showStudyPlanModal: showPlanModal.value
          }, null, 8, ["showStudyPlanModal"]))
        : _createCommentVNode("", true),
      (currentPage.value == 3)
        ? (_openBlock(), _createBlock(ThirdScenePage, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    (showVideoPlayer.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_vkm_videoPlayer, {
            onOnClose: _cache[3] || (_cache[3] = ()=>{showVideoPlayer.value = false}),
            videoSrc: videoResource.value
          }, null, 8, ["videoSrc"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})